export default __webpack_public_path__ + "static/media/yas-island.59e1f8b3.svg";